import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import "./ContactMe.css";
import emailjs from "emailjs-com";
import AOS from "aos";
import "aos/dist/aos.css";

const ContactMe = () => {
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_x6uw38u",
        "template_3lgsxcj",
        e.target,
        "user_JVJTM68Zclpo5EONI2DF7"
      )
      .then(
        (result) => {
          console.log(result.text);
          if (result.text) {
            alert(" Thank You for Contacting Me");
            document.getElementById("contact-form").reset();
          }
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <Container
      data-aos="fade-left"
      className="container-fluid my-5 py-5 p-5 bg-body contact-me-shadow font"
    >
      <h2 className="text-center mb-3">
        CONTACT <span className="heading">Me</span>
      </h2>
      <div className="row align-items-center gx-5">
        <div className="col-lg-6 align-items-center">
          <br />
          <h3>Get In Touch</h3>
          <form id="contact-form" onSubmit={sendEmail}>
            <div className="mb-3">
              <label className="form-label">Enter Name</label>
              <input
                placeholder="Enter your name"
                type="name"
                name="name"
                id="formBasicEmail"
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Enter Email </label>
              <input
                placeholder="Enter your email"
                type="email"
                name="email"
                id="formBasicEmail"
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Your Message</label>
              <textarea
                placeholder="Enter your message"
                type="text"
                name="message"
                className="form-control"
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Send <i class="fas fa-paper-plane"></i>
            </button>
          </form>
        </div>
        <div className="col-lg-6 mt-3">
          <h2>Contact Info</h2>
          <ul className="text-muted">
            <li>Kolabagan, Dhanmondi, Dhaka-1205</li>
            <li>(+880) 01752362400</li>
            <li>moshiur.ra01@gmail.com</li>
          </ul>
        </div>
      </div>
    </Container>
  );
};

export default ContactMe;
